export interface MessagesState {
    items: MessageInfo[];
}

export interface MessageInfo {
    type: MessageType;
    payload: {
        campaignId: string;
    };
}

export enum MessageType {
    MODERATION = 'moderation'
}
